import { useState, useEffect } from 'react';
var Orientations;
(function (Orientations) {
    Orientations[Orientations["PORTRAIT"] = 0] = "PORTRAIT";
    Orientations[Orientations["LANDSCAPE"] = 1] = "LANDSCAPE";
})(Orientations || (Orientations = {}));
const portraitOrientations = [0, 180];
/** TODO: This hook uses the deprecated `window.orientation` web api feature and may
 * cease to function on the various platforms. However, Apple, in their infinite wisdom
 * have elected not to support the screen web api so we must use this for iOS devices.
 * Should update to detect the platform and utilize the screen web api instead where
 * applicable to avoid any potential breakages in the future */
const useOrientationChange = () => {
    const initialOrientation = portraitOrientations.includes(window.orientation)
        ? 'PORTRAIT'
        : 'LANDSCAPE';
    const [orientation, setOrientation] = useState(initialOrientation);
    useEffect(() => {
        const handler = () => {
            const updatedOrientation = portraitOrientations.includes(window.orientation)
                ? 'PORTRAIT'
                : 'LANDSCAPE';
            setOrientation(updatedOrientation);
        };
        window.addEventListener('orientationchange', handler);
        return () => {
            window.removeEventListener('orientationchange', handler);
        };
    }, []);
    return orientation;
};
export default useOrientationChange;
//# sourceMappingURL=useOrientationChange.js.map